import gql from 'graphql-tag'
export const fetchRemoveMultipleFreeBeer = gql(`
mutation ($input: [FreeBeerInput]!) {
    freeBeerCartRemove(
      input: $input
    ) {
      success_message
      error_message
      iFreebeerProductCartQty
      iFillUpLayerQty
      item_id
      __typename
    }
  }`)
